updateOpenStatus(); // initial open status
updateOperatingHours(); // show store hours
setInterval(updateOpenStatus, 1000); // update the status every second

function updateOperatingHours() {
    const HFJoperatingHoursElement = document.getElementById("operating-hours");
    var operatingHoursHTML = '<table><tr><td><b>Monday</b></td><td class="align-right">9:30AM&nbsp;-&nbsp;5:00PM</td></tr><tr><td><b>Tuesday</b></td><td class="align-right">9:30AM&nbsp;-&nbsp;5:00PM</td></tr><tr><td><b>Wednesday</b></td><td class="align-right">9:30AM&nbsp;-&nbsp;5:00PM</td></tr><tr><td><b>Thursday</b></td><td class="align-right">9:30AM&nbsp;-&nbsp;5:00PM</td></tr><tr><td><b>Friday</b></td><td class="align-right">9:30AM&nbsp;-&nbsp;5:00PM</td></tr><tr><td><b>Saturday</b></td><td class="align-right">9:30AM&nbsp;-&nbsp;5:00PM</td></tr><tr><td><b>Sunday</b></td><td class="align-right">CLOSED</td></tr></table>';
    HFJoperatingHoursElement.innerHTML = operatingHoursHTML;
}

function updateOpenStatus() {
    const HFJopenStatusElement = document.getElementById('is-howards-open');
    
    const currentWeekday = new Intl.DateTimeFormat('en-US', {timeZone: 'America/Toronto', weekday: 'long'}).format(new Date());
    const currentDate = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Toronto', dateStyle: 'full'}).format(new Date());
    const currentTime = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Toronto', hour: 'numeric', minute: 'numeric', second: 'numeric'}).format(new Date());
    var YOWTimezone = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Toronto', timeZoneName: 'short'}).format(new Date());
    YOWTimezone = YOWTimezone.split(" ")[1]; // strip the datestamp

    const mondayOpeningTime = '9:30AM';
    const mondayClosingTime = '5:00PM';
    
    const isOpenMonday = true;
    
    
    const tuesdayOpeningTime = '9:30AM';
    const tuesdayClosingTime = '5:00PM';
    
    const isOpenTuesday = true;
    
    
    const wednesdayOpeningTime = '9:30AM';
    const wednesdayClosingTime = '5:00PM';
    
    const isOpenWednesday = true;
    
    
    const thursdayOpeningTime = '9:30AM';
    const thursdayClosingTime = '5:00PM';
    
    const isOpenThursday = true;
    
    
    const fridayOpeningTime = '9:30AM';
    const fridayClosingTime = '5:00PM';
    
    const isOpenFriday = true;
    
    
    const saturdayOpeningTime = '9:30AM';
    const saturdayClosingTime = '5:00PM';
    
    const isOpenSaturday = true;
    
    
    const sundayOpeningTime = '11:00AM';
    const sundayClosingTime = '4:00PM';
    
    const isOpenSunday = false;
    
    
    const closedClassName = 'hours-of-operation-closed';
    const openClassName = 'hours-of-operation-open';
    
    const openMondayStatusMessage = '<span class="' + closedClassName + '">Closed</span> &#x2022; Open Monday at ' + mondayOpeningTime;
    const openTuesdayStatusMessage = '<span class="' + closedClassName + '">Closed</span> &#x2022; Open Tuesday at ' + tuesdayOpeningTime;
    const openWednesdayStatusMessage = '<span class="' + closedClassName + '">Closed</span> &#x2022; Open Wednesday at ' + wednesdayOpeningTime;
    const openThursdayStatusMessage = '<span class="' + closedClassName + '">Closed</span> &#x2022; Open Thursday at ' + thursdayOpeningTime;
    const openFridayStatusMessage = '<span class="' + closedClassName + '">Closed</span> &#x2022; Open Friday at ' + fridayOpeningTime;
    const openSaturdayStatusMessage = '<span class="' + closedClassName + '">Closed</span> &#x2022; Open Saturday at ' + saturdayOpeningTime;
    const openSundayStatusMessage = '<span class="' + closedClassName + '">Closed</span> &#x2022; Open Sunday at ' + sundayOpeningTime;
    const openNextMondayStatusMessage = '<span class="' + closedClassName + '">Closed</span> &#x2022; Open next Monday at ' + mondayOpeningTime;
    const openNextTuesdayStatusMessage = '<span class="' + closedClassName + '">Closed</span> &#x2022; Open next Tuesday at ' + tuesdayOpeningTime;
    const openNextWednesdayStatusMessage = '<span class="' + closedClassName + '">Closed</span> &#x2022; Open next Wednesday at ' + wednesdayOpeningTime;
    const openNextThursdayStatusMessage = '<span class="' + closedClassName + '">Closed</span> &#x2022; Open next Thursday at ' + thursdayOpeningTime;

    const openLaterTodayPreambleStatusMessage = '<span class="fixed16 ebony-black bold right-padding-10">Currently Closed</span> <span class="fixed16 nowrap emerald-green right-padding-5">Open at ';
    const openLaterTodayPostambleStatusMessage = ' today <svg id="rolexHoursToggleArrow" width="12" height="12" xmlns="http://www.w3.org/2000/svg"><polygon points="0,3 12,3 6,9" fill="currentcolor"></polygon></svg></span>';
    const openTodayPreambleStatusMessage = '<span class="fixed16 ebony-black bold right-padding-10">Open today</span> <span class="fixed16 nowrap emerald-green right-padding-5">';
    const openTodayPostambleStatusMessage = ' <svg id="rolexHoursToggleArrow" width="12" height="12" xmlns="http://www.w3.org/2000/svg"><polygon points="0,3 12,3 6,9" fill="currentcolor"></polygon></svg></span>';
    const openTomorrowPreambleStatusMessage = '<span class="fixed16 ebony-black bold right-padding-10">Currently Closed</span> <span class="fixed16 emerald-green right-padding-5" style="white-space: nowrap;">Open at ';
    const openTomorrowPostambleStatusMessage = ' tomorrow <svg id="rolexHoursToggleArrow" width="12" height="12" xmlns="http://www.w3.org/2000/svg"><polygon points="0,3 12,3 6,9" fill="currentcolor"></polygon></svg></span>';
    const openLaterPostambleStatusMessage = ' <svg id="rolexHoursToggleArrow" width="12" height="12" xmlns="http://www.w3.org/2000/svg"><polygon points="0,3 12,3 6,9" fill="currentcolor"></polygon></svg></span>';
    const closedStatusMessage = '<span class="' + closedClassName + '">Closed at the moment</span>';
    
    const currentTimestamp = Date.parse(currentDate + " " + currentTime + " " + YOWTimezone);

    var HFJopenStatusMessage = "";
    
    if (currentWeekday == "Monday") 
    {
        // take the opening time from the schema and format it to ensure there is a space between the time and AM/PM
        var unsanitizedOpeningTime = mondayOpeningTime;
        var sanitizedOpeningTime = unsanitizedOpeningTime.replace('AM', ' AM');
        sanitizedOpeningTime = sanitizedOpeningTime.replace('PM', ' PM');

        // take the closing time from the schema and format it to ensure there is a space between the time and AM/PM
        var unsanitizedClosingTime = mondayClosingTime;
        var sanitizedClosingTime = unsanitizedClosingTime.replace('AM', ' AM');
        sanitizedClosingTime = sanitizedClosingTime.replace('PM', ' PM');

        const openingTimestamp = Date.parse(currentDate + ' ' + sanitizedOpeningTime + ' ' + YOWTimezone);
        const closingTimestamp = Date.parse(currentDate + ' ' + sanitizedClosingTime + ' ' + YOWTimezone);

        if (currentTimestamp < openingTimestamp && isOpenMonday) 
        {
            HFJopenStatusMessage = openLaterTodayPreambleStatusMessage + unsanitizedOpeningTime + openLaterTodayPostambleStatusMessage;
        }
        else if (currentTimestamp >= openingTimestamp && currentTimestamp < closingTimestamp && isOpenMonday) 
        {
            HFJopenStatusMessage = openTodayPreambleStatusMessage + unsanitizedOpeningTime + " - " + unsanitizedClosingTime + openTodayPostambleStatusMessage;
        }
        else if (currentTimestamp >= closingTimestamp || !isOpenMonday) 
        {
            if (isOpenTuesday)
            {
                HFJopenStatusMessage = openTomorrowPreambleStatusMessage + tuesdayOpeningTime + openTomorrowPostambleStatusMessage;
            }
            else if (isOpenWednesday)
            {
                HFJopenStatusMessage = openWednesdayStatusMessage;
            }
            else if (isOpenThursday)
            {
                HFJopenStatusMessage = openThursdayStatusMessage;
            }
            else if (isOpenFriday)
            {
                HFJopenStatusMessage = openFridayStatusMessage;
            }
            else if (isOpenSaturday)
            {
                HFJopenStatusMessage = openSaturdayStatusMessage;
            }
            else if (isOpenSunday)
            {
                HFJopenStatusMessage = openSundayStatusMessage;
            }
            else
            {
                HFJopenStatusMessage = closedStatusMessage;
            }
        }
    }
    else if (currentWeekday == "Tuesday") 
    {
        // take the opening time from the schema and format it to ensure there is a space between the time and AM/PM
        var unsanitizedOpeningTime = tuesdayOpeningTime;
        var sanitizedOpeningTime = unsanitizedOpeningTime.replace('AM', ' AM');
        sanitizedOpeningTime = sanitizedOpeningTime.replace('PM', ' PM');

        // take the closing time from the schema and format it to ensure there is a space between the time and AM/PM
        var unsanitizedClosingTime = tuesdayClosingTime;
        var sanitizedClosingTime = unsanitizedClosingTime.replace('AM', ' AM');
        sanitizedClosingTime = sanitizedClosingTime.replace('PM', ' PM');

        const openingTimestamp = Date.parse(currentDate + ' ' + sanitizedOpeningTime + ' ' + YOWTimezone);
        const closingTimestamp = Date.parse(currentDate + ' ' + sanitizedClosingTime + ' ' + YOWTimezone);

        if (currentTimestamp < openingTimestamp && isOpenTuesday) 
        {
            HFJopenStatusMessage = openLaterTodayPreambleStatusMessage + unsanitizedOpeningTime + openLaterTodayPostambleStatusMessage;
        }
        else if (currentTimestamp >= openingTimestamp && currentTimestamp < closingTimestamp && isOpenTuesday) 
        {
            HFJopenStatusMessage = openTodayPreambleStatusMessage + unsanitizedOpeningTime + " - " + unsanitizedClosingTime + openTodayPostambleStatusMessage;
        }
        else if (currentTimestamp >= closingTimestamp || !isOpenTuesday) 
        {
            if (isOpenWednesday)
            {
                HFJopenStatusMessage = openTomorrowPreambleStatusMessage + wednesdayOpeningTime + openTomorrowPostambleStatusMessage;
            }
            else if (isOpenThursday)
            {
                HFJopenStatusMessage = openThursdayStatusMessage;
            }
            else if (isOpenFriday)
            {
                HFJopenStatusMessage = openFridayStatusMessage;
            }
            else if (isOpenSaturday)
            {
                HFJopenStatusMessage = openSaturdayStatusMessage;
            }
            else if (isOpenSunday)
            {
                HFJopenStatusMessage = openSundayStatusMessage;
            }
            else if (isOpenMonday)
            {
                HFJopenStatusMessage = openNextMondayStatusMessage;
            }
            else
            {
                HFJopenStatusMessage = closedStatusMessage;
            }
        }
    }
    else if (currentWeekday == "Wednesday") 
    {
        // take the opening time from the schema and format it to ensure there is a space between the time and AM/PM
        var unsanitizedOpeningTime = wednesdayOpeningTime;
        var sanitizedOpeningTime = unsanitizedOpeningTime.replace('AM', ' AM');
        sanitizedOpeningTime = sanitizedOpeningTime.replace('PM', ' PM');

        // take the closing time from the schema and format it to ensure there is a space between the time and AM/PM
        var unsanitizedClosingTime = wednesdayClosingTime;
        var sanitizedClosingTime = unsanitizedClosingTime.replace('AM', ' AM');
        sanitizedClosingTime = sanitizedClosingTime.replace('PM', ' PM');

        const openingTimestamp = Date.parse(currentDate + ' ' + sanitizedOpeningTime + ' ' + YOWTimezone);
        const closingTimestamp = Date.parse(currentDate + ' ' + sanitizedClosingTime + ' ' + YOWTimezone);

        if (currentTimestamp < openingTimestamp && isOpenWednesday) 
        {
            HFJopenStatusMessage = openLaterTodayPreambleStatusMessage + unsanitizedOpeningTime + openLaterTodayPostambleStatusMessage;
        }
        else if (currentTimestamp >= openingTimestamp && currentTimestamp < closingTimestamp && isOpenWednesday) 
        {
            HFJopenStatusMessage = openTodayPreambleStatusMessage + unsanitizedOpeningTime + " - " + unsanitizedClosingTime + openTodayPostambleStatusMessage;
        }
        else if (currentTimestamp >= closingTimestamp || !isOpenWednesday) 
        {
            if (isOpenThursday)
            {
                HFJopenStatusMessage = openTomorrowPreambleStatusMessage + thursdayOpeningTime + openTomorrowPostambleStatusMessage;
            }
            else if (isOpenFriday)
            {
                HFJopenStatusMessage = openFridayStatusMessage;
            }
            else if (isOpenSaturday)
            {
                HFJopenStatusMessage = openSaturdayStatusMessage;
            }
            else if (isOpenSunday)
            {
                HFJopenStatusMessage = openSundayStatusMessage;
            }
            else if (isOpenMonday)
            {
                HFJopenStatusMessage = openNextMondayStatusMessage;
            }
            else if (isOpenTuesday)
            {
                HFJopenStatusMessage = openNextTuesdayStatusMessage;
            }
            else
            {
                HFJopenStatusMessage = closedStatusMessage;
            }
        }
    }
    else if (currentWeekday == "Thursday") 
    {
        // take the opening time from the schema and format it to ensure there is a space between the time and AM/PM
        var unsanitizedOpeningTime = thursdayOpeningTime;
        var sanitizedOpeningTime = unsanitizedOpeningTime.replace('AM', ' AM');
        sanitizedOpeningTime = sanitizedOpeningTime.replace('PM', ' PM');

        // take the closing time from the schema and format it to ensure there is a space between the time and AM/PM
        var unsanitizedClosingTime = thursdayClosingTime;
        var sanitizedClosingTime = unsanitizedClosingTime.replace('AM', ' AM');
        sanitizedClosingTime = sanitizedClosingTime.replace('PM', ' PM');

        const openingTimestamp = Date.parse(currentDate + ' ' + sanitizedOpeningTime + ' ' + YOWTimezone);
        const closingTimestamp = Date.parse(currentDate + ' ' + sanitizedClosingTime + ' ' + YOWTimezone);

        if (currentTimestamp < openingTimestamp && isOpenThursday) 
        {
            HFJopenStatusMessage = openLaterTodayPreambleStatusMessage + unsanitizedOpeningTime + openLaterTodayPostambleStatusMessage;
        }
        else if (currentTimestamp >= openingTimestamp && currentTimestamp < closingTimestamp && isOpenThursday) 
        {
            HFJopenStatusMessage = openTodayPreambleStatusMessage + unsanitizedOpeningTime + " - " + unsanitizedClosingTime + openTodayPostambleStatusMessage;
        }
        else if (currentTimestamp >= closingTimestamp || !isOpenThursday) 
        {
            if (isOpenFriday)
            {
                HFJopenStatusMessage = openTomorrowPreambleStatusMessage + fridayOpeningTime + openTomorrowPostambleStatusMessage;
            }
            else if (isOpenSaturday)
            {
                HFJopenStatusMessage = openSaturdayStatusMessage;
            }
            else if (isOpenSunday)
            {
                HFJopenStatusMessage = openSundayStatusMessage;
            }
            else if (isOpenMonday)
            {
                HFJopenStatusMessage = openNextMondayStatusMessage;
            }
            else if (isOpenTuesday)
            {
                HFJopenStatusMessage = openNextTuesdayStatusMessage;
            }
            else if (isOpenWednesday)
            {
                HFJopenStatusMessage = openNextWednesdayStatusMessage;
            }
            else
            {
                HFJopenStatusMessage = closedStatusMessage;
            }
        }
    }
    else if (currentWeekday == "Friday") 
    {
        // take the opening time from the schema and format it to ensure there is a space between the time and AM/PM
        var unsanitizedOpeningTime = fridayOpeningTime;
        var sanitizedOpeningTime = unsanitizedOpeningTime.replace('AM', ' AM');
        sanitizedOpeningTime = sanitizedOpeningTime.replace('PM', ' PM');

        // take the closing time from the schema and format it to ensure there is a space between the time and AM/PM
        var unsanitizedClosingTime = fridayClosingTime;
        var sanitizedClosingTime = unsanitizedClosingTime.replace('AM', ' AM');
        sanitizedClosingTime = sanitizedClosingTime.replace('PM', ' PM');

        const openingTimestamp = Date.parse(currentDate + ' ' + sanitizedOpeningTime + ' ' + YOWTimezone);
        const closingTimestamp = Date.parse(currentDate + ' ' + sanitizedClosingTime + ' ' + YOWTimezone);

        if (currentTimestamp < openingTimestamp && isOpenFriday) 
        {
            HFJopenStatusMessage = openLaterTodayPreambleStatusMessage + unsanitizedOpeningTime + openLaterTodayPostambleStatusMessage;
        }
        else if (currentTimestamp >= openingTimestamp && currentTimestamp < closingTimestamp && isOpenFriday) 
        {
            HFJopenStatusMessage = openTodayPreambleStatusMessage + unsanitizedOpeningTime + " - " + unsanitizedClosingTime + openTodayPostambleStatusMessage;
        }
        else if (currentTimestamp >= closingTimestamp || !isOpenFriday) 
        {
            if (isOpenSaturday)
            {
                HFJopenStatusMessage = openTomorrowPreambleStatusMessage + saturdayOpeningTime + openTomorrowPostambleStatusMessage;
            }
            else if (isOpenSunday)
            {
                HFJopenStatusMessage = openSundayStatusMessage;
            }
            else if (isOpenMonday)
            {
                HFJopenStatusMessage = openNextMondayStatusMessage;
            }
            else if (isOpenTuesday)
            {
                HFJopenStatusMessage = openNextTuesdayStatusMessage;
            }
            else if (isOpenWednesday)
            {
                HFJopenStatusMessage = openNextWednesdayStatusMessage;
            }
            else if (isOpenThursday)
            {
                HFJopenStatusMessage = openNextThursdayStatusMessage;
            }
            else
            {
                HFJopenStatusMessage = closedStatusMessage;
            }
        }
    }
    else if (currentWeekday == "Saturday") 
    {
        // take the opening time from the schema and format it to ensure there is a space between the time and AM/PM
        var unsanitizedOpeningTime = saturdayOpeningTime;
        var sanitizedOpeningTime = unsanitizedOpeningTime.replace('AM', ' AM');
        sanitizedOpeningTime = sanitizedOpeningTime.replace('PM', ' PM');

        // take the closing time from the schema and format it to ensure there is a space between the time and AM/PM
        var unsanitizedClosingTime = saturdayClosingTime;
        var sanitizedClosingTime = unsanitizedClosingTime.replace('AM', ' AM');
        sanitizedClosingTime = sanitizedClosingTime.replace('PM', ' PM');

        const openingTimestamp = Date.parse(currentDate + ' ' + sanitizedOpeningTime + ' ' + YOWTimezone);
        const closingTimestamp = Date.parse(currentDate + ' ' + sanitizedClosingTime + ' ' + YOWTimezone);

        if (currentTimestamp < openingTimestamp && isOpenSaturday) 
        {
            HFJopenStatusMessage = openLaterTodayPreambleStatusMessage + unsanitizedOpeningTime + openLaterTodayPostambleStatusMessage;
        }
        else if (currentTimestamp >= openingTimestamp && currentTimestamp < closingTimestamp && isOpenSaturday) 
        {
            HFJopenStatusMessage = openTodayPreambleStatusMessage + unsanitizedOpeningTime + " - " + unsanitizedClosingTime + openTodayPostambleStatusMessage;
        }
        else if (currentTimestamp >= closingTimestamp || !isOpenSaturday) 
        {
            if (isOpenSunday)
            {
                HFJopenStatusMessage = openTomorrowPreambleStatusMessage + sundayOpeningTime + openTomorrowPostambleStatusMessage;
            }
            else if (isOpenMonday)
            {
                HFJopenStatusMessage = openMondayStatusMessage;
            }
            else if (isOpenTuesday)
            {
                HFJopenStatusMessage = openTuesdayStatusMessage;
            }
            else if (isOpenWednesday)
            {
                HFJopenStatusMessage = openNextWednesdayStatusMessage;
            }
            else if (isOpenThursday)
            {
                HFJopenStatusMessage = openThursdayStatusMessage;
            }
            else if (isOpenFriday)
            {
                HFJopenStatusMessage = openFridayStatusMessage;
            }
            else
            {
                HFJopenStatusMessage = closedStatusMessage;
            }
        }
    }
    else if (currentWeekday == "Sunday") 
    {
        // take the opening time from the schema and format it to ensure there is a space between the time and AM/PM
        var unsanitizedOpeningTime = sundayOpeningTime;
        var sanitizedOpeningTime = unsanitizedOpeningTime.replace('AM', ' AM');
        sanitizedOpeningTime = sanitizedOpeningTime.replace('PM', ' PM');

        // take the closing time from the schema and format it to ensure there is a space between the time and AM/PM
        var unsanitizedClosingTime = sundayClosingTime;
        var sanitizedClosingTime = unsanitizedClosingTime.replace('AM', ' AM');
        sanitizedClosingTime = sanitizedClosingTime.replace('PM', ' PM');

        const openingTimestamp = Date.parse(currentDate + ' ' + sanitizedOpeningTime + ' ' + YOWTimezone);
        const closingTimestamp = Date.parse(currentDate + ' ' + sanitizedClosingTime + ' ' + YOWTimezone);

        if (currentTimestamp < openingTimestamp && isOpenSunday) 
        {
            HFJopenStatusMessage = openLaterTodayPreambleStatusMessage + unsanitizedOpeningTime + openLaterTodayPostambleStatusMessage;
        }
        else if (currentTimestamp >= openingTimestamp && currentTimestamp < closingTimestamp && isOpenSunday) 
        {
            HFJopenStatusMessage = openTodayPreambleStatusMessage + unsanitizedOpeningTime + " - " + unsanitizedClosingTime + openTodayPostambleStatusMessage;
        }
        else if (currentTimestamp >= closingTimestamp || !isOpenSunday) 
        {
            if (isOpenMonday)
            {
                HFJopenStatusMessage = openTomorrowPreambleStatusMessage + mondayOpeningTime + openTomorrowPostambleStatusMessage;
            }
            else if (isOpenTuesday)
            {
                HFJopenStatusMessage = openTuesdayStatusMessage;
            }
            else if (isOpenWednesday)
            {
                HFJopenStatusMessage = openNextWednesdayStatusMessage;
            }
            else if (isOpenThursday)
            {
                HFJopenStatusMessage = openThursdayStatusMessage;
            }
            else if (isOpenFriday)
            {
                HFJopenStatusMessage = openFridayStatusMessage;
            }
            else if (isOpenSaturday)
            {
                HFJopenStatusMessage = openSaturdayStatusMessage;
            }
            else
            {
                HFJopenStatusMessage = closedStatusMessage;
            }
        }
    }
    
    // add the string to the layer
    HFJopenStatusElement.innerHTML = HFJopenStatusMessage;
}

// when a user clicks on the Rolex hours, toggle between showing & hiding the dropdown menu containing the daily hours of operation
function displayHours() 
{
    document.getElementById('operating-hours').classList.toggle('hours-are-hidden');
}

// close the Rolex hours of operation dropdown menu if the user clicks outside of it
window.onclick = function(event) 
{
    const toggle = document.getElementById('is-howards-open');
    const dropdown = document.getElementById('operating-hours');
    if (!dropdown.contains(event.target) && !toggle.contains(event.target)) 
    {
        if (!dropdown.classList.contains('hours-are-hidden')) {
            dropdown.classList.add('hours-are-hidden');  
        }
    }
} 